/**
 * VAT locales
 * @type {object}
 */
export const vatLocales = {
  'es-AR': 'IVA',
  'en-AU': 'GST',
  'de-AT': 'USt',
  'bn-BD': 'ভ্যাট',
  'nl-BE': 'BTW',
  'fr-BE': 'TVA',
  'pt-BR': 'ICMS',
  'en-CA': 'GST/HST',
  'fr-CA': 'TPS/TVH',
  'es-CL': 'IVA',
  'zh-CN': '增值税',
  'es-CO': 'IVA',
  'cs-CZ': 'DPH',
  'da-DK': 'MOMS',
  'fi-FI': 'ALV',
  'fr-FR': 'TVA',
  'de-DE': 'USt',
  'el-GR': 'ΦΠΑ',
  'zh-HK': '增值稅',
  'hu-HU': 'ÁFA',
  'bn-IN': 'ভ্যাট',
  'en-IN': 'GST',
  'hi-IN': 'वैट',
  'ta-IN': 'வரி',
  'id-ID': 'PPN',
  'en-IE': 'VAT',
  'he-IL': 'מע"מ',
  'it-IT': 'IVA',
  'jp-JP': '消費税',
  'es-MX': 'IVA',
  'nl-NL': 'BTW',
  'en-NZ': 'GST',
  'no-NO': 'MVA',
  'pl-PL': 'VAT',
  'pt-PT': 'IVA',
  'ko-KR': '부가가치세',
  'ro-RO': 'TVA',
  'ru-RU': 'НДС',
  'ar-SA': 'ضريبة القيمة المضافة',
  'sk-SK': 'DPH',
  'en-ZA': 'VAT',
  'es-ES': 'IVA',
  'ta-LK': 'வரி',
  'sv-SE': 'MOMS',
  'de-CH': 'MWST',
  'fr-CH': 'TVA',
  'it-CH': 'IVA',
  'zh-TW': '增值稅',
  'th-TH': 'ภาษีมูลค่าเพิ่ม',
  'tr-TR': 'KDV',
  'en-GB': 'VAT',
};

/**
 * Get the VAT locale for a given locale
 * @param {string} locale
 * @param {string} vatName
 * @returns {string}
 */
export function getVatLocale(locale, vatName) {
  return vatLocales[locale] || vatName;
}
